import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SxProps,
  FormHelperText,
} from "@mui/material";
import { useValidationBlur } from "../../hooks/use-validation-blur";

export const OutlinedSelect = <T = string,>({
  label,
  inputRef,
  value,
  onChange,
  sx,
  options,
  size = "small",
  multiple = false,
  wrapperSx,
  error,
  name,
  disabled,
  required,
  forceValidate,
}: {
  name?: string;
  size?: "small" | "medium";
  label?: string;
  inputRef?: (input: HTMLSelectElement | null) => void;
  value: T;
  onChange: (e: T) => void;
  sx?: SxProps;
  wrapperSx?: SxProps;
  options?: (string | { label: string; value: string | number })[];
  multiple?: boolean;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  forceValidate?: boolean;
}) => {
  const { shouldValidate, onBlur } = useValidationBlur();
  const showError = !!error && (shouldValidate || !!forceValidate);

  return (
    <FormControl
      error={showError}
      sx={{ width: "100%", ...wrapperSx }}
      disabled={disabled}
      required={required}
    >
      <InputLabel size={size}>{label}</InputLabel>
      <Select<T>
        onBlur={onBlur}
        name={name}
        inputRef={inputRef}
        label={label}
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        size={size}
        MenuProps={{
          elevation: 16,
        }}
        sx={sx}
        multiple={multiple}
        error={showError}
        disabled={disabled}
      >
        {options?.map((option) => {
          const isString = typeof option === "string";
          const value = isString ? option : option.value;
          const label = isString ? option : option.label;
          return (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
      {showError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
